import Navbar from "./navbar/Navbar";
import Tabsbar from "./Tabsbar";

function Layout({ lang, langcode, personal, update_p }, props) {
  return (
    <>
      <Navbar lang={lang} langcode={langcode} personal={personal} update_p={update_p} ></Navbar>
      {props.children}
      <Tabsbar />
    </>
  )
}
export default Layout;